module.exports = __webpack_public_path__ + "img/press-release-min.87b83f4e.png";